/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useFormContext } from "react-hook-form";
import { Switch } from "@nordcloud/gnui";
import { Fieldset } from "~/components/Forms";
import { SidebarFormFieldProps } from "~/components/SidebarForm/SidebarFormField";

type Props = {
  name: string;
  defaultValue?: boolean;
} & SidebarFormFieldProps;

function SidebarSwitch(props: Props) {
  const { register, setValue, watch } = useFormContext();

  React.useEffect(() => {
    register({ name: props.name });
  }, [props, register]);

  React.useEffect(() => {
    setValue(props.name, props.defaultValue || false);
  }, [setValue, props.name, props.defaultValue]);

  return (
    <Fieldset>
      <Switch
        position="right"
        labelText={props.label}
        checked={watch(props.name)}
        onChange={(event) => setValue(props.name, event.target.checked)}
      />
    </Fieldset>
  );
}

export { SidebarSwitch };
